import React from 'react';

import classNames from 'classnames';

import { ExternalLink } from 'features/order-tracker/shared-components';
import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';
import { APPOINTMENT_TYPES } from 'features/order-tracker/utils/entries';

import {
  AMEND_APPOINTMENT_DISABLED_MESSAGE,
  APPOINTMENT_DESCRIPTION_TEXT_BY_STATUS,
  APPOINTMENT_DESC_ENGG_VISIT_TEXT_BY_STATUS,
  KCI2_ASSURE_APPOINTMENT_TEXT,
  PONR_DESCRIPTION_ENGINEERING_VISIT,
  PONR_DESCRIPTION_EXPERT_SETUP,
} from './constants';

import styles from './styles.module.scss';

export const AppointmentDescription: React.FC<components.AppointmentDescription> = ({
  status,
  isKci2AssureOrder,
  isAmendAppointmentEnabled,
  isStatusPONR,
  type,
}) => {
  const APPOINTMENT_DESCRIPTION =
    type === APPOINTMENT_TYPES.expert
      ? APPOINTMENT_DESCRIPTION_TEXT_BY_STATUS
      : APPOINTMENT_DESC_ENGG_VISIT_TEXT_BY_STATUS;

  const PONR_DESCRIPTION =
    type === APPOINTMENT_TYPES.expert ? PONR_DESCRIPTION_EXPERT_SETUP : PONR_DESCRIPTION_ENGINEERING_VISIT;

  const [descriptionStart, descriptionEnd = ''] = isAmendAppointmentEnabled
    ? APPOINTMENT_DESCRIPTION[status]
    : AMEND_APPOINTMENT_DISABLED_MESSAGE;
  const descriptionClassNames = classNames(
    styles.description,
    AQA_ELEMENTS_MARKER_LIST.summaryPage.appointments.appointmentsDescription,
  );

  if (isKci2AssureOrder) {
    return <p className={descriptionClassNames}>{KCI2_ASSURE_APPOINTMENT_TEXT}</p>;
  }

  if (isStatusPONR) {
    return (
      <p>
        {PONR_DESCRIPTION.text}
        <ExternalLink
          link={PONR_DESCRIPTION.linkUrl}
          text={PONR_DESCRIPTION.linkText}
          className={styles.link}
          withIcon={false}
        />
      </p>
    );
  }

  return (
    <p className={descriptionClassNames}>
      {descriptionStart}
      {descriptionEnd}
    </p>
  );
};
